<mat-nav-list>
  <a *ngFor="let url of urls" [href]="url.url" mat-list-item (click)="openLink($event, url)">
    <span mat-line>{{ url.title }}</span>
  </a>
</mat-nav-list>
